import { select } from 'redux-saga/effects';
import { SetSelectedTimelinesAction } from '../actions';
import LocalCache from '../../../../pages/local-storage/local-storage';

export function* watchSetSelectedTimelines(action: SetSelectedTimelinesAction) {
  const user = yield select(({ user }) => user);
  const localCache = new LocalCache('crewSchedulingV2', user);
  localCache.setCached('selectedTimelines', action.payload.selectedTimelines);
}
